export enum TooltipKey {
  budgetTooltip = 'budgetTooltip',
  emailsTooltip = 'emailsTooltip',
  positionPathPhaseTooltip = 'positionPathPhaseTooltip',
  ballTooltip = 'ballTooltip',
  pathPhaseTooltip = 'pathPhaseTooltip',
  pathPhaseCompanyTooltip = 'pathPhaseCompanyTooltip',
  validityPeriodDaysTooltip = 'validityPeriodDaysTooltip',
  startDateTooltip = 'startDateTooltip',
  nameForClientsTooltip = 'nameForClientsTooltip',
  specialistTeamTooltip = 'specialistTeamTooltip',
  emailToTooltip = 'emailToTooltip',
  contractorTypeTooltip = 'contractorTypeTooltip',
  setReadyToInvoiceTooltip = 'setReadyToInvoiceTooltip',
  projectPathPhasesTooltip = 'projectPathPhasesTooltip',
  orderPhaseTooltip = 'orderPhaseTooltip',
  projectFromOrderPathPhasesTooltip = 'projectFromOrderPathPhasesTooltip',
  positionTeamsTooltip = 'positionTeamsTooltip',
  dealGroupNumberTooltip = 'dealGroupNumberTooltip',
  salesInvoicingMonthTooltip = 'salesInvoicingMonthTooltip',
  salesInvoicingHideInvoicedTooltip = 'salesInvoicingHideInvoicedTooltip',
  salesInvoicingMailTeamTooltip = 'salesInvoicingMailTeamTooltip',
  salesInvoicingMailRecipientsTooltip = 'salesInvoicingMailRecipientsTooltip',
  salesInvoicingMailSendToTeamTooltip = 'salesInvoicingMailSendToTeamTooltip',
  salesInvoicingMailEmailsTooltip = 'salesInvoicingMailEmailsTooltip',
  salesInvoicingMailRangeMonthTooltip = 'salesInvoicingMailRangeMonthTooltip',
  salesInvoicingMailMessageTooltip = 'salesInvoicingMailMessageTooltip',
  purchaseDeficienciesMailTeamTooltip = 'purchaseDeficienciesMailTeamTooltip',
  purchaseDeficienciesMailRecipientsTooltip = 'purchaseDeficienciesMailRecipientsTooltip',
  purchaseDeficienciesMailRangeMonthTooltip = 'purchaseDeficienciesMailRangeMonthTooltip',
}

export const TooltipDescription: Record<TooltipKey, string> = {
  [TooltipKey.budgetTooltip]: "Pole 'Budżet' w formularzach kampanii/projektów",
  [TooltipKey.emailsTooltip]: "Pole 'E-maile' w konfiguracji importu Excel",
  [TooltipKey.positionPathPhaseTooltip]: "Pole 'Faza' w pozycji mediaplanu",
  [TooltipKey.ballTooltip]: "Pole 'Produkt' (Kulka) w pozycji mediaplanu",
  [TooltipKey.pathPhaseTooltip]: "Pole 'Faza' w edycji zespołu (administracja)",
  [TooltipKey.pathPhaseCompanyTooltip]:
    'Przełącznik faz w edycji spółki (administracja)',
  [TooltipKey.validityPeriodDaysTooltip]:
    "Pole 'Okres ważności' w definicji ankiety (ankiety)",
  [TooltipKey.startDateTooltip]:
    "Pole 'Data rozpoczęcia' w definicji ankiety (ankiety)",
  [TooltipKey.nameForClientsTooltip]:
    "Pole 'Nazwa dla klientów' w definicji ankiety (ankiety)",
  [TooltipKey.specialistTeamTooltip]:
    "Pole 'Zespół realizujący' w pozycji mediaplanu",
  [TooltipKey.emailToTooltip]:
    "Pole 'Adresy e-mail odbiorców' w formularzu ponownego wysyłania e-maila (E-maile)",
  [TooltipKey.contractorTypeTooltip]:
    "Pole 'Typ kontrahenta' w definicji ankiety (ankiety)",
  [TooltipKey.setReadyToInvoiceTooltip]:
    "Pole 'Ustaw jako gotowe do fakturowania' w konfiguracji importu Excel",
  [TooltipKey.projectPathPhasesTooltip]:
    "Pole 'Fazy' w formularzu tworzenia/edycji kampanii/projektu",
  [TooltipKey.orderPhaseTooltip]:
    "Pole 'Faza zamówienia' w formularzu zamówienia",
  [TooltipKey.projectFromOrderPathPhasesTooltip]:
    "Pole 'Fazy' w formularzu kampanii/projektu (z zamówienia)",
  [TooltipKey.positionTeamsTooltip]:
    "Pole 'Zespoły realizujące' w formularzu tworzenia/edycji pozycji profilu",
  [TooltipKey.dealGroupNumberTooltip]:
    "Pole 'Grupowanie deali' w formularzu kontrahenta",
  [TooltipKey.salesInvoicingMonthTooltip]:
    "Pole 'Miesiąc' w zestawieniu Sprzedaż - zafakturowanie",
  [TooltipKey.salesInvoicingHideInvoicedTooltip]:
    "Pole 'Ukryj zafakturowane' w zestawieniu Sprzedaż - zafakturowanie",
  [TooltipKey.salesInvoicingMailTeamTooltip]:
    "Pole 'Zespół' w formularzu wysyłki e-mail zestawienia Sprzedaż - zafakturowanie",
  [TooltipKey.salesInvoicingMailRecipientsTooltip]:
    "Pole 'Odbiorcy' w formularzu wysyłki e-mail zestawienia Sprzedaż - zafakturowanie",
  [TooltipKey.salesInvoicingMailSendToTeamTooltip]:
    "Pole 'Wyślij e-mail na adres zespołu' w formularzu wysyłki e-mail zestawienia Sprzedaż - zafakturowanie",
  [TooltipKey.salesInvoicingMailEmailsTooltip]:
    "Pole 'Adresy e-mail' w formularzu wysyłki e-mail zestawienia Sprzedaż - zafakturowanie",
  [TooltipKey.salesInvoicingMailRangeMonthTooltip]:
    "Pole 'Zakres miesięcy' w formularzu wysyłki e-mail zestawienia Sprzedaż - zafakturowanie",
  [TooltipKey.salesInvoicingMailMessageTooltip]:
    "Pole 'Wiadomość' w formularzu wysyłki e-mail zestawienia Sprzedaż - zafakturowanie",
  [TooltipKey.purchaseDeficienciesMailTeamTooltip]:
    "Pole 'Zespół' w formularzu wysyłki e-mail zestawienia Braki FVZ",
  [TooltipKey.purchaseDeficienciesMailRecipientsTooltip]:
    "Pole 'Odbiorcy' w formularzu wysyłki e-mail zestawienia Braki FVZ",
  [TooltipKey.purchaseDeficienciesMailRangeMonthTooltip]:
    "Pole 'Zakres miesięcy' w formularzu wysyłki e-mail zestawienia Braki FVZ",
};
